module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/c2d70c1d9d21a95ded384c8963de6d09.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_1.svg
// module id = 6ywA
// module chunks = 0